import { Anchor, Card } from '@zenid/web';
import { genericError } from '../../../../styled-system/recipes';

type Props = {
  logout?: boolean;
};

export function Unauthorized({ logout }: Props) {
  const { contentsLayout, contentsInnerLayout, iconLayout, icon, title, messageLayout, message, actionsLayout } =
    genericError();
  return (
    <Card className={contentsLayout}>
      <div className={contentsInnerLayout}>
        <div className={iconLayout}>
          <img
            src={`${import.meta.env.VITE_ASSETS_URL}/assets/images/seagull_meal.png`}
            className={icon}
            alt="エラーページのアイコン"
          />
        </div>
        <div className={messageLayout}>
          <h1 className={title}>認証エラー</h1>
          <p className={message}>認証に失敗しました。正しい手順で操作しているか再度ご確認ください。</p>
        </div>
        <div className={actionsLayout}>
          {logout ? (
            <Anchor variant="button" href="/logout" color="primary" size="l" width={200}>
              ログアウト
            </Anchor>
          ) : (
            <Anchor variant="button" href="/home" color="primary" size="l" width={200}>
              ZEN IDに戻る
            </Anchor>
          )}
        </div>
      </div>
    </Card>
  );
}
